import React from "react";

/**
 * STRIANO NCC — Logo ufficiale (SVG inline, 3 varianti).
 * Design: S serif ornata grande, arco circolare oro, wordmark serif ampio
 * sottolineatura dorata · "NOLEGGIO CON CONDUCENTE · ROMA".
 * Palette: nero #000000, oro #D4AF6A/#E8CA7F/#8C6E2A, avorio #F5EDD6.
 */
export default function StrianoLogo({ variant = "full", size = 56, className = "", onBg = "dark", ...rest }) {
  const defs = (
    <defs>
      <linearGradient id="snccGoldV" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#F8E7A6"/>
        <stop offset="35%" stopColor="#E8CA7F"/>
        <stop offset="55%" stopColor="#D4AF6A"/>
        <stop offset="100%" stopColor="#8C6E2A"/>
      </linearGradient>
      <linearGradient id="snccGoldH" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#8C6E2A"/>
        <stop offset="18%" stopColor="#D4AF6A"/>
        <stop offset="50%" stopColor="#F3DF9B"/>
        <stop offset="82%" stopColor="#D4AF6A"/>
        <stop offset="100%" stopColor="#8C6E2A"/>
      </linearGradient>
      <linearGradient id="snccSilver" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#F5F2E8"/>
        <stop offset="100%" stopColor="#B9B4A3"/>
      </linearGradient>
      <radialGradient id="snccGlow" cx="50%" cy="40%" r="55%">
        <stop offset="0%" stopColor="#F3DF9B" stopOpacity="0.35"/>
        <stop offset="60%" stopColor="#F3DF9B" stopOpacity="0.08"/>
        <stop offset="100%" stopColor="#000" stopOpacity="0"/>
      </radialGradient>
    </defs>
  );

  // S serif ornata (path stilizzato grande)
  const SMono = ({ fill }) => (
    <g>
      {/* glow */}
      <circle cx="100" cy="90" r="78" fill="url(#snccGlow)"/>
      {/* arco circolare oro */}
      <path d="M 32 90 A 68 68 0 1 1 168 90" fill="none" stroke="url(#snccGoldH)" strokeWidth="1.2" strokeLinecap="round"/>
      {/* S ornata serif */}
      <path
        d="M 128 44
           C 118 38 104 36 92 38
           C 76 40 64 52 62 68
           C 60 82 70 92 88 98
           L 108 104
           C 118 107 124 112 123 120
           C 122 128 112 134 100 134
           C 86 134 76 128 70 118
           L 64 114
           C 64 128 72 138 86 142
           C 94 144 102 144 110 142
           L 112 144
           L 112 156
           L 108 156
           L 106 150
           C 94 152 82 150 72 142
           C 60 132 58 118 64 106
           C 70 94 84 90 100 94
           L 120 98
           C 128 100 134 95 134 88
           C 134 80 126 74 114 74
           C 102 74 92 80 86 92
           L 80 90
           C 80 76 90 66 106 62
           L 108 60
           L 108 48
           L 112 48
           L 114 54
           C 122 54 128 54 134 58
           Z"
        fill={fill}
        stroke="#8C6E2A"
        strokeWidth="0.4"
      />
      {/* highlight centrale lucido */}
      <path d="M 96 72 Q 100 76 104 72 L 102 90 Q 100 94 98 90 Z" fill="#FFF4CF" opacity="0.4"/>
    </g>
  );

  if (variant === "compact") {
    const h = size, w = size;
    return (
      <svg data-testid="striano-logo-compact" viewBox="0 0 200 200" width={w} height={h} className={className} {...rest}>
        {defs}
        <circle cx="100" cy="100" r="96" fill="#0A0A0C" stroke="url(#snccGoldH)" strokeWidth="1.5"/>
        <g transform="translate(0,10)"><SMono fill="url(#snccGoldV)"/></g>
      </svg>
    );
  }

  if (variant === "mono") {
    const fg = onBg === "light" ? "#0A0A0C" : "#F5EDD6";
    const h = size, w = Math.round(size * (560 / 200));
    return (
      <svg data-testid="striano-logo-mono" viewBox="0 0 560 200" width={w} height={h} className={className} {...rest}>
        <g transform="translate(0,0)">
          <circle cx="100" cy="100" r="90" fill="none" stroke={fg} strokeWidth="1"/>
          <path d="M 128 44 C 118 38 104 36 92 38 C 76 40 64 52 62 68 C 60 82 70 92 88 98 L 108 104 C 118 107 124 112 123 120 C 122 128 112 134 100 134 C 86 134 76 128 70 118 L 64 114 C 64 128 72 138 86 142 C 94 144 102 144 110 142 L 112 144 L 112 156 L 108 156 L 106 150 C 94 152 82 150 72 142 C 60 132 58 118 64 106 C 70 94 84 90 100 94 L 120 98 C 128 100 134 95 134 88 C 134 80 126 74 114 74 C 102 74 92 80 86 92 L 80 90 C 80 76 90 66 106 62 L 108 60 L 108 48 L 112 48 L 114 54 C 122 54 128 54 134 58 Z"
                fill={fg}/>
        </g>
        <g transform="translate(210,120)" fill={fg}>
          <text fontFamily="Georgia, 'Times New Roman', serif" fontSize="52" fontWeight="700" letterSpacing="4">STRIANO NCC</text>
          <text y="26" fontFamily="Helvetica, Arial, sans-serif" fontSize="13" letterSpacing="7" opacity="0.75">NOLEGGIO CON CONDUCENTE</text>
          <text y="48" fontFamily="Helvetica, Arial, sans-serif" fontSize="14" letterSpacing="10" fontWeight="700">ROMA</text>
        </g>
      </svg>
    );
  }

  // FULL — matching reference image: big ornate S on top, STRIANO NCC centered large, subtitle, ROMA
  const h = size, w = Math.round(size * (560 / 300));
  return (
    <svg data-testid="striano-logo-full" viewBox="0 0 560 300" width={w} height={h} className={className} {...rest}>
      {defs}
      {/* S monogramma centrale alto */}
      <g transform="translate(180,0)"><SMono fill="url(#snccGoldV)"/></g>
      {/* STRIANO + NCC wordmark (single text with tspan per color split) */}
      <text x="280" y="220" textAnchor="middle" fontFamily="Georgia, 'Times New Roman', serif" fontSize="54" fontWeight="700" letterSpacing="4">
        <tspan fill="url(#snccGoldV)">STRIANO</tspan>
        <tspan fill="url(#snccSilver)" dx="22">NCC</tspan>
      </text>
      {/* linea dorata sotto il wordmark */}
      <line x1="110" y1="238" x2="450" y2="238" stroke="url(#snccGoldH)" strokeWidth="0.8"/>
      {/* sottotitolo */}
      <text x="280" y="258" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontSize="14" letterSpacing="7" fill="url(#snccSilver)" opacity="0.9">NOLEGGIO CON CONDUCENTE</text>
      <text x="280" y="282" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontSize="15" letterSpacing="12" fontWeight="700" fill="url(#snccGoldV)">ROMA</text>
    </svg>
  );
}
